export default function validatePresence(
  name: string,
  value: string | null | undefined,
  message = `Please enter your ${name}.`,
): string | null {
  const valid = !!value

  return valid ? null : message
}
